import script from "./mainMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./mainMenu.vue?vue&type=script&lang=ts&setup=true"

import "./mainMenu.vue?vue&type=style&index=0&id=a21b8ece&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a21b8ece"]])

export default __exports__